/*
 * @Descripttion: 画布活动列表页
 * @Author: yang chenglin
 */
import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { history } from 'ice';
import {
  Tab,
  Table,
  Form,
  Input,
  Button,
  DatePicker,
  Balloon,
  Select,
  Checkbox,
} from '@alifd/next';
import CreateBtn from '@/components/common/CreateBtn';
import CanvasUtil from '@/components/canvas/CONSTANT';
import LzMsg from '@/components/common/LzMsg';
import LzPagination from '@/components/common/LzPagination';
import LzDialog from '@/components/common/LzDialog';
import CanvasDialog from '@/components/canvas/CreateActivity/createActivity';
import DetailDialog from '@/components/canvas/CreateActivity/activityDetail';
// import FunctionUseSummary from '@/pages/PrivateDedicatedWaiterInvite/components/FunctionUseSummary';
import utils from '@/common/utils';
import { CanvasService, Servlets } from '@/service';
import styles from './index.module.scss';
import { allNodes } from '../Edit/Nodes';
import ConfirmDialog from '@/components/Dialog/ConfirmDialog';
// 运营公告弹窗
// import SMSDialog from '../PrivateSMSManage/Dialog';
// 运营活动弹窗
// import OperationDialog from '@/components/sms/OperationDialog';
// import PageUtils from '@/components/sms/OperationDialog/utils';

import STEP1 from '@/assets/images/CanvasImages/step-1.png';
import STEP2 from '@/assets/images/CanvasImages/step-2.png';
import STEP3 from '@/assets/images/CanvasImages/step-3.png';
import STEP4 from '@/assets/images/CanvasImages/step-4.png';
import STEPICON1 from '@/assets/images/CanvasImages/steps-item-icon1.png';
import STEPICON2 from '@/assets/images/CanvasImages/steps-item-icon2.png';
import STEPICON3 from '@/assets/images/CanvasImages/steps-item-icon3.png';
import STEPICON4 from '@/assets/images/CanvasImages/steps-item-icon4.png';
import HELP from '@/assets/images/CanvasImages/help.png';
import VIDEO from '@/assets/images/CanvasImages/video.png';
// 首页展示说明内容
const HEADERDESC = [
  {
    id: 1,
    bg: STEP1,
    icon: STEPICON1,
    title: '画布人群创建',
    desc: '可通过营销画布快捷创建并选择触达人群',
  },
  {
    id: 2,
    bg: STEP2,
    icon: STEPICON2,
    title: '画布人群运算',
    desc: '可通过营销画布实现人群：交/并/差/拆分/去重运算',
  },
  {
    id: 3,
    bg: STEP3,
    icon: STEPICON3,
    title: '画布营销触点',
    desc: '画布操作人群可通过短信/富信/站内消息进行触达，也可直接保存或进行人群包分析',
  },
  {
    id: 4,
    bg: STEP4,
    icon: STEPICON4,
    title: '更多的营销模板',
    desc: '画布内置多种营销活动模板可直接调用进行创建',
  },
];

let intervals = null;

const formItemLayout = {
  labelCol: { fixedSpan: 4 },
};

const statusList = [
  // 活动状态列表
  {
    name: '未提交',
    key: 0,
    classname: styles.stateText,
    progressSpeed: styles.noSpeed,
  },
  {
    name: '预执行',
    key: 1,
    classname: styles.stateText,
    progressSpeed: styles.noSpeed,
  },
  {
    name: '待执行',
    key: 2,
    classname: styles.stateText,
    progressSpeed: styles.noSpeed,
  },
  {
    name: '执行中',
    key: 3,
    classname: styles.success,
    progressSpeed: styles.successSpeed,
  },
  {
    name: '已暂停',
    key: 4,
    classname: styles.error,
    progressSpeed: styles.errorSpeed,
  },
  {
    name: '已停止',
    key: 5,
    classname: styles.error,
    progressSpeed: styles.errorSpeed,
  },
  {
    name: '已完成',
    key: 9,
    classname: styles.success,
    progressSpeed: styles.successSpeed,
  },
];
// 节点数据
const nodeData = [];
export default function List(props) {
  // const [showOperationDialog, setShowOperationDialog] = useState(false); // 是否展示运营活动弹窗

  // 判断当前商家是否需要弹出短信优惠弹窗
  // const checkShowDialog = async () => {
  //   const result = await showCreateDialog();
  //   if (!result) {
  //     history.push(`/private/activities`, { source: 'editor' });
  //   }
  // }

  // const showCreateDialog = async () => {
  //   const bool = await PageUtils.showCampaign(0);
  //   setShowOperationDialog(bool);
  //   return bool;
  // }

  useEffect(() => {
    utils.setBreadcrumb({
      name: '营销画布', // 一级页面名称
      url: '/web/canvas/activities', // 一级页面url
      // children: {
      //   name: '任务管理', // 二级页面名称
      //   url: '/web/canvas/activities', // 二级页面url
      // },
    });
  }, []);

  const [isShowFncSummary, setIsShowFncSummary] = useState(true);
  const [showNotice, setShowNotice] = useState(false); // 画布2.1通知弹窗
  const [isCheck, setCheck] = useState(); //画布2.1通知弹窗是否选择了不再展示
  const [canvasData, setCanvasData] = useState({ ...CanvasUtil.initCreateActivityForm });

  const [isLoading, setLoading] = useState(false);
  // 控制新建活动弹窗是否展示变量
  const [strategyFlag, setStrategyFlag] = useState(false);
  // 控制活动详情弹窗是否展示变量
  const [activityDetailFlag, setActivityDetailFlag] = useState(false);
  // 控制列表数据确认删除/执行中活动确认停止弹窗
  const [deleteItemFlag, setDeleteItemFlag] = useState(false);
  const [deleteItemType, setDeleteItemType] = useState(''); // del-删除，stop-停止
  // 对选中的某一条即将操作的数据id进行暂存
  const [activityIdBuffer, setActivityId] = useState(null);
  // 弹窗title,可能是新增，可能是修改
  const [dialogTitle, setDialogTitle] = useState(1); // 活动弹窗类型 1-新建 2-复制 3-修改
  const [copyActivityId, setCopyId] = useState(null);
  // 活动form查询条件
  const [formSelectStatus, setFormSelectStatus] = useState({
    campaignName: '', // 活动名称
    startTime: '', // 活动开始时间
    endTime: '', // 活动结束时间
    cycleType: '', // 循环方式
    campaignState: null, // 活动状态
  });
  // 由于当前页面有定时器刷列表状态，所以缓存了一份状态值，初始值要保证和 formSelectStatus 一致（PS：并没有在useEffect中去同步，个人感觉会有延迟）
  const [secondaryStatu, setSecondaryStatus] = useState({
    campaignName: '', // 活动名称
    startTime: '', // 活动开始时间
    endTime: '', // 活动结束时间
    cycleType: '', // 循环方式
    campaignState: null, // 活动状态
  });
  // 列表渲染的数组
  const [activityData, setActivityData] = useState([]);
  // 点击展示的活动任务数详情
  const [taskDetailList, setTasklist] = useState([]);
  // 点击展示的活动进度详情
  const [loopDetailList, setLooplist] = useState([]);
  // 点击展示的活动循环次数详情
  const [processDetailList, setProcesslist] = useState([]);
  // 分页数据
  const [pageInfo, setPageInfo] = useState({
    pageNo: 1,
    pageSize: 10,
    total: 0,
  });

  // 画布2.1弹窗不再展示
  const handleCheck = (v) => {
    setCheck(v);
    localStorage.setItem('isShowFncDialogCanvasThirdTips', JSON.stringify(!v));
  }
  /**
   * 初始化创建/修改表单的值
   */
  const initCanvasData = () => {
    setCanvasData({ ...CanvasUtil.initCreateActivityForm });
  };
  /**
   * 选择时间
   */
  const changeActivityTime = (val) => {
    let startT = '';
    let endT = '';
    startT = val[0] ? moment(val[0]).format('YYYY-MM-DD') : '';
    endT = val[1] ? moment(val[1]).format('YYYY-MM-DD') : '';
    setFormSelectStatus({
      ...formSelectStatus,
      startTime: startT,
      endTime: endT,
    });
  };
  /**
   * 翻页方法
   */
  const handlePageSizeChange = async (pages = {}) => {
    try {
      searchActivityList({ pageSize: pages.pageSize, pageNo: pages.pageNo });
    } catch (e) {
      setLoading(false);
      LzMsg.error(e.message);
    }
  };
  /**
   * 点击查询按钮触发
   */
  const searchBtnFun = () => {
    setSecondaryStatus({
      ...secondaryStatu,
      ...formSelectStatus,
    });
    searchActivityList(
      { pageNo: 1, pageSize: pageInfo.pageSize, ...formSelectStatus },
      true
    );
  };
  /**
   * 请求活动列表
   * @param v-当次查询改变的请求接口的参数
   * @param isNewState-点击查询和重置时，区别于前端定时器刷新走接口，它可能会带着新状态过来，且campaignState这个参数需要读取状态进行2^n计算，所以传一个标识来确认是什么情况的调用接口
   */
  const searchActivityList = (v, isNewState = false) => {
    setLoading(true);
    const params = {
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
      campaignName: secondaryStatu.campaignName,
      cycleType: secondaryStatu.cycleType,
      ...v,
      startTime: isNewState
        ? v.startTime
          ? moment(`${v.startTime} 00:00:00`).valueOf()
          : ''
        : secondaryStatu.startTime
          ? moment(`${secondaryStatu.startTime} 00:00:00`).valueOf()
          : '',
      endTime: isNewState
        ? v.endTime
          ? moment(`${v.endTime} 23:59:59`).valueOf()
          : ''
        : secondaryStatu.endTime
          ? moment(`${secondaryStatu.endTime} 23:59:59`).valueOf()
          : '',
      campaignState: isNewState
        ? v.campaignState ||
          (v.campaignState === 0 &&
            v.campaignState !== null &&
            v.campaignState !== '')
          ? Math.pow(2, v.campaignState)
          : null
        : secondaryStatu.campaignState || secondaryStatu.campaignState === 0
          ? Math.pow(2, secondaryStatu.campaignState)
          : null,
    };
    CanvasService.getActivityList(params)
      .then((res) => {
        if(res.success) {
          setLoading(false);
          setActivityData(res.data);
          setPageInfo({
            ...pageInfo,
            pageNo: v.pageNo,
            pageSize: v.pageSize,
            total: res.page.total,
          });
        } else {
          LzMsg.error(res.resp_msg);
        }
      })
      .catch(() => {
        setLoading(false);
      });
  };
  /**
   * 重置筛选数据
   */
  const resetFilter = () => {
    setFormSelectStatus({
      ...formSelectStatus,
      campaignName: '',
      startTime: '',
      endTime: '',
      cycleType: '',
      campaignState: null,
    });
    // 由于我们维护了一个暂存变量去查询列表，便于interval，所以重置也要将这个数据同步
    setSecondaryStatus({
      ...secondaryStatu,
      campaignName: '',
      startTime: '',
      endTime: '',
      cycleType: '', // 循环方式
      campaignState: null,
    });
    searchActivityList(
      {
        pageNo: 1,
        pageSize: pageInfo.pageSize,
        campaignName: '',
        startTime: '',
        endTime: '',
        cycleType: '',
        campaignState: null,
      },
      true
    );
  };

  // 列表上的字段点击展示事件
  /**
   * 查询活动任务详情
   */
  const searchActivityTaskDetail = (item) => {
    const lists = JSON.parse(JSON.stringify(CanvasUtil.nodeType));

    item.canvasProcessDetail.processDesignModel.childShapes.forEach((it) => {
      lists.forEach((list) => {
        if (it.resourceType === list.key) {
          list.value += 1;
        }
      });
    });
    setTasklist(lists);
  };
  /**
   * 查询活动循环执行详情
   */
  // 查循环执行详情
  const searchActivityLoopDetail = async (item) => {
    const lists = [
      // 为不同次数执行状态提供匹配数组
      {
        name: '执行中',
        value: 3,
        classname: styles.success,
        progressSpeed: styles.successSpeed,
      },
      {
        name: '已暂停',
        value: 4,
        classname: styles.error,
        progressSpeed: styles.errorSpeed,
      },
      {
        name: '已停止',
        value: 5,
        classname: styles.error,
        progressSpeed: styles.errorSpeed,
      },
      {
        name: '已完成',
        value: 9,
        classname: styles.success,
        progressSpeed: styles.successSpeed,
      },
    ];
    const bufList = [];
    item.canvasProcessDetail.processRuntimeData.forEach((pro, index) => {
      // 判断当次活动是不是有执行失败的节点，样式需要展示警示叹号
      let tips = false;
      item.canvasProcessDetail.processRuntimeData[
        item.cycleIndex ? item.cycleIndex - 1 : 0
      ].actInsts.forEach((it) => {
        if (
          item.canvasProcessDetail.processRuntimeData[
            item.cycleIndex ? item.cycleIndex - 1 : 0
          ].errorMsg[`${it.resourceId}`]
        ) {
          tips = true;
        }
      });

      lists.forEach((lis) => {
        if (lis.value === pro.status) {
          bufList.push({
            name: index + 1,
            currentProgress: pro.progress,
            key: lis.value,
            tips,
          });
        }
      });
    });
    setLooplist(bufList);
  };
  /**
   * 查询当前循环执行进度详情
   */
  const searchActivityProcessDetail = (item) => {
    const lists = [
      // 每次请求当前任务数详情，根据这个数组定义的节点类型去匹配每类节点的数量
      {
        name: '等待执行',
        value: 0,
      },
      {
        name: '执行中',
        value: 0,
      },
      {
        name: '执行完成',
        value: 0,
      },
      {
        name: '执行错误',
        value: 0,
      },
    ];
    if (item.campaignState === 0 || item.campaignState === 2) {
      lists[0].value = item.jobNum;
      setProcesslist(lists);
    } else {
      item.canvasProcessDetail.processRuntimeData[
        item.cycleIndex ? item.cycleIndex - 1 : 0
      ].actInsts.forEach((it) => {
        if (
          it.actInstData &&
          item.canvasProcessDetail.processRuntimeData[
            item.cycleIndex ? item.cycleIndex - 1 : 0
          ].errorMsg[`${it.resourceId}`]
        ) {
          lists[3].value += 1;
        } else if (
          it.actInstData &&
          it.actInstData.startTime &&
          it.actInstData.endTime &&
          it.actInstData.endTime !== -1
        ) {
          lists[2].value += 1;
        } else if (
          it.actInstData &&
          it.actInstData.startTime &&
          it.actInstData.endTime === -1 &&
          !item.canvasProcessDetail.processRuntimeData[
            item.cycleIndex ? item.cycleIndex - 1 : 0
          ].errorMsg[`${it.resourceId}`]
        ) {
          lists[1].value += 1;
        } else {
          lists[0].value += 1;
        }
      });
      // 如果执行中的数组节点个数小于总任务数，就把相差的节点都置为待执行
      const differs =
        item.canvasProcessDetail.campaign.jobNum -
        item.canvasProcessDetail.processRuntimeData[
          item.cycleIndex ? item.cycleIndex - 1 : 0
        ].actInsts.length;
      if (differs !== 0) {
        lists[0].value += differs;
      }
      setProcesslist(lists);
    }
  };
  // 活动操作
  /**
   * 查看活动
   */
  const viewActivityDetail = (item) => {
    setCanvasData(item);
    setActivityDetailFlag(!activityDetailFlag);
  };
  /**
   * 更新活动
   */
  const editActivityMessage = (item) => {
    setCanvasData(item);
    setCopyId(item.id);
    setDialogTitle(3);
    setStrategyFlag(!strategyFlag);
  };
  /**
   * 二次确认
   * @param type-二次确认的类型 del-删除活动 stop-停止活动
   */
  const secondConfirmDelete = (campaignId, type) => {
    setActivityId(campaignId);
    setDeleteItemFlag(!deleteItemFlag);
    setDeleteItemType(type); // 设置弹窗类型是删除活动的二次确认弹窗
  };
  /**
   * 删除活动
   */
  const deleteAvtivity = () => {
    CanvasService.deleteActivityList([activityIdBuffer])
      .then((res) => {
        if(res.success) {
          setDeleteItemFlag(false);
          LzMsg.success('删除成功');
          searchActivityList({
            pageNo: pageInfo.pageNo,
            pageSize: pageInfo.pageSize,
          });
        } else {
          LzMsg.error(res.resp_msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  /**
   * 查看报表
   */
  const viewAnalysis = (item) => {
    window.open(`../canvas/activities/data/analysis/${item.id}`);
  };
  // 流程操作
  /**
   * 校验节点是否过期
   */
  const checkExpiredNode = async (canvasProcessDetail) => {
    const timeDiffer = new Date(new Date().toDateString()).getTime();
    const nodeList = canvasProcessDetail.processDesignModel.childShapes;
    // 我不懂之前的开发到底怎么设计的这个接口，达成了什么样的协议，继续沿用
    let realSign = '';
    await Servlets('getTitle', {}).then(async (res: { data: string }) => {
      const { shopName } = res.data;
      await Servlets('getSmssign', { shopName }).then((res: { data: string }) => {
        if (!res.data) {
          return;
        }
        realSign = res.data;
      });
    });
    const maxTime = Math.max(
      new Date().getTime(),
      canvasProcessDetail.campaign.executionPlan?.crowdStartTime
    )
    await Promise.all(
      nodeList.map(async (node) => {
        try {
          //   if (node.formProperties.cycleType) {
          //     if (
          //       node.formProperties.executionTime < timeDiffer &&
          //       node.formProperties.executionTime !== 946656000000
          //     ) {
          //       throw new Error('此活动存在过期节点');
          //     }
          //   }
          if (node.resourceType === 'MARKETING_MSG_BOX') {
            if (node.data.executionTime < timeDiffer) {
              throw new Error(`${node.formProperties.name}节点已过期`);
            }
          }
          if (node.resourceType === 'MARKETING_SMS') {
            if (node.formProperties.smsSign !== realSign) {
              throw new Error('短信节点的签名同当前店铺已生效的签名不符，请重新配置后再提交！');
            }
            if (node.formProperties.executionTime !== 0 && node.formProperties.executionTime < timeDiffer) {
              throw new Error(`${node.formProperties.name}节点已过期`);
            }
          }
          if (node.resourceType === 'MARKETING_RICH_TEXT_SMS') {
            if (node.formProperties.sign !== realSign) {
              throw new Error('富信节点的签名同当前店铺已生效的签名不符，请重新配置后再提交！');
            }
            if (node.formProperties.executionTime !== 0 && node.formProperties.executionTime < timeDiffer) {
              throw new Error(`${node.formProperties.name}节点已过期`);
            }
            if (utils.Len(node.formProperties.sign, 16)) {
              throw new Error('富信节点签名需保证16个字符（8个汉字）以内，请修改');
            }
            if (canvasProcessDetail.campaign.executionPlan.timeDifference === 1 && canvasProcessDetail.campaign.executionPlan?.crowdStartTime && node.formProperties.executionTime < maxTime + 10 * 60 * 1000) {
              throw new Error(`${node.formProperties.name}节点投放时间应大于当前时间10分钟并且大于画布开始执行时间10分钟`);
            }
          }
        } catch (e) {
          const errorMessage = e;
          throw new Error(errorMessage);
        }
      })
    );
  };
  /**
   * 校验节点信息是否完整
   */
  const checkAllNodes = async (canvasProcessDetail) => {
    // 清理一下节点数据
    nodeData.length = 0;
    const nodeList = canvasProcessDetail.processDesignModel.childShapes;
    nodeList.forEach((item) => {
      // 这个元素是个节点，在节点列表中根据节点的resourceType匹配节点的前端数据
      const initNode = allNodes.filter(
        (n) => n.info.name === item.resourceType
      )[0];
      // nodeData中存节点的信息
      if (initNode) {
        nodeData.push({
          nodeId: item.resourceId,
          ...initNode?.create(item.formProperties),
        });
      }
    });
    await Promise.all(
      nodeData.map(async (node) => {
        try {
          if (node.info.name === 'CROWD_EXTRACT') {
            // 拆分
            if (!node.data.extractType) {
              // 如果是点击弹窗的关闭，或者直接连接上级节点但并未打开抽取弹窗进行编辑，就不能给preActName赋值，会把其余错误挡住，抽取节点提前判断一下其他表单内容
              throw new Error('人群抽取类型不能为空');
            }
          }
          // 检测优惠券节点所选择的优惠券是否依然存在
          if (node.info.name === 'MARKETING_COUPON' && node.data.couponRecordId) {
            let coponCanUse;
            await CanvasService.checkrecordcanuse({ recordId: node.data.couponRecordId }).then(res => {
              coponCanUse = res.data;
            }).catch(e => {
              console.log(e)
            });
            if (!coponCanUse) {
              throw new Error('优惠券已不存在，请重新选择');
            }
          }
          // 校验节点的数据
          await node.validate();
        } catch (e) {
          const errorMessage = `${node.info.label}节点设置有误：${e.message}`;
          throw new Error(errorMessage);
        }
      })
    );
  };
  /**
   * 提交
   */
  const submitActivity = async (item) => {
    try {
      if (item.executionPlan.type === 1) {
        await checkExpiredNode(item.canvasProcessDetail);
      }
      await checkAllNodes(item.canvasProcessDetail);
      CanvasService.submitActivity({
        campaignId: item.id,
      })
        .then((res) => {
          if(res.success) {
            LzMsg.success('提交成功');
            searchActivityList({
              pageNo: pageInfo.pageNo,
              pageSize: pageInfo.pageSize,
            });
          } else {
            LzMsg.error(res.resp_msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      LzMsg.error(e.message);
    }
  };
  /**
   * 继续
   */
  const continueActivity = async (item) => {
    try {
      if (item.executionPlan.type === 1) {
        await checkExpiredNode(item.canvasProcessDetail);
      }
      CanvasService.continueActivity({
        campaignId: item.id,
      })
        .then((res) => {
          if (res.success) {
            LzMsg.success('继续成功');
            searchActivityList({
              pageNo: pageInfo.pageNo,
              pageSize: pageInfo.pageSize,
            });
          } else {
            LzMsg.error(res.resp_msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } catch (e) {
      LzMsg.error(e.message);
    }
  };
  /**
   * 暂停
   */
  const pauseActivity = (campaignId) => {
    CanvasService.pauseActivity({
      campaignId,
    })
      .then((res) => {
        LzMsg.success('暂停成功');
        searchActivityList({
          pageNo: pageInfo.pageNo,
          pageSize: pageInfo.pageSize,
        });
      })
      .catch((e) => {
        console.log(e);
      });
  };
  /**
   * 停止
   */
  const stopActivity = () => {
    CanvasService.stopActivity({
      campaignId: activityIdBuffer,
    })
      .then((res) => {
        if(res.success) {
          setDeleteItemFlag(false);
          LzMsg.success('停止活动成功');
          searchActivityList({
            pageNo: pageInfo.pageNo,
            pageSize: pageInfo.pageSize,
          });
        } else {
          LzMsg.error(res.resp_msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  /**
   * 停止预执行
   */
  const stopPreActivity = (campaignId) => {
    CanvasService.stopPreActivity({ campaignId })
      .then((res) => {
        if(res.success) {
          LzMsg.success('预执行已停止');
          searchActivityList({
            pageNo: pageInfo.pageNo,
            pageSize: pageInfo.pageSize,
          });
        } else {
          LzMsg.error(res.resp_msg);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  /**
   * 编辑画布流程
   */
  const editActivity = (item) => {
    history.push(`activities/${item.id}/editor/`);
  };
  /**
   * 查看画布详情
   */
  const viewCanvasDetail = (item) => {
    if (item.campaignState === 1) {
      window.open(`activities/${item.id}/preview/`);
    } else {
      window.open(`activities/${item.id}/detail/`);
    }
  };

  /**
   * 弹窗保存营销活动 dialogTitle 1:新增 2：复制 3：修改
   */
  const saveFormData = (formdata) => {
    const params = {
      endTime: formdata.executionPlan.endTime
        ? formdata.executionPlan.endTime
        : '',
      frequencyType: formdata.executionPlan.frequencyType,
      frequencyValue: formdata.executionPlan.frequencyValue,
      startHour: formdata.executionPlan.startHour,
      startMinute: formdata.executionPlan.startMinute,
      startTime: formdata.executionPlan.startTime
        ? formdata.executionPlan.startTime
        : '',
      crowdStartTime: formdata.executionPlan.crowdStartTime
        ? Date.parse(formdata.executionPlan.crowdStartTime)
        : '',
      type: formdata.executionPlan.type,
      instancePackType: 1, // 判断是否带有消息盒子，固定传1，无意义
      timeDifference: formdata.executionPlan.timeDifference,
      checkPassFlag: 0
    };
    if (dialogTitle === 1) {
      CanvasService.createActivity({
        campaignName: formdata.campaignName,
        campaignRemark: formdata.campaignRemark,
        executionPlan: params,
      })
        .then((res) => {
          if(res.success) {
            setStrategyFlag(false);
            LzMsg.success('创建成功');
            searchActivityList({ pageNo: 1, pageSize: pageInfo.pageSize });
            editActivity(res.data);
          } else {
            LzMsg.error(res.resp_msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (dialogTitle === 2) {
      CanvasService.copyActivityList({
        campaignId: copyActivityId,
        newCampaignName: formdata.campaignName,
        newCampaignRemark: formdata.campaignRemark,
        // crowdStartTime: params.timeDifference === 0 ? new Date().getTime() : params.crowdStartTime,
        // timeDifference: params.timeDifference,
        executionPlan: params,
      })
        .then((res) => {
          if(res.success) {
            setStrategyFlag(false);
            LzMsg.success('复制成功');
            searchActivityList({ pageNo: 1, pageSize: pageInfo.pageSize });
          } else {
            LzMsg.error(res.resp_msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    } else if (dialogTitle === 3) {
      CanvasService.updateActivityList({
        campaignId: copyActivityId,
        campaignName: formdata.campaignName,
        campaignRemark: formdata.campaignRemark,
        executionPlan: params,
      })
        .then((res) => {
          if(res.success) {
            setStrategyFlag(false);
            LzMsg.success('更新成功');
            searchActivityList({
              pageNo: pageInfo.pageNo,
              pageSize: pageInfo.pageSize,
            });
          } else {
            LzMsg.error(res.resp_msg);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };
  /**
   * 弹窗退出事件
   */
  const canvasCancel = () => {
    setStrategyFlag(false);
  };

  /**
   * 判断流程操作第三个按钮（提交，暂停，继续）操作如何展示
   * @param ProcessBtn: 可以操作的按钮
   * @param ProcessSpan: 禁用的按钮
   * @return 不同状态赋予不同点击事件和图标 (processkey不为空，证明已经在画布画出流程)
   */
  const ProcessBtn = ({ icon, text, onClick }) => {
    return (
      <Balloon.Tooltip
        align="t"
        trigger={
          <span className={`iconfont ${icon}`} onClick={() => onClick()} />
        }
        closable={false}
      >
        {text}
      </Balloon.Tooltip>
    );
  };
  const ProcessSpan = ({ icon }) => {
    return <span className={`iconfont ${styles['disable-copy']} ${icon}`} />;
  };
  const checkOperationStatus = (item) => {
    if (item.campaignState === 0 && item.processKey !== '' && item.executionPlan.checkPassFlag === 1) {
      // 未提交且processkey不为空且节点校验通过，可以进行提交操作
      return (
        <ProcessBtn
          icon="icon-icon4-20"
          text="提交"
          onClick={() => submitActivity(item)}
        />
      );
    } else if (item.campaignState === 0 && item.processKey !== '' && item.executionPlan.checkPassFlag === 0) {
      // 未提交且processkey不为空且节点校验未通过，不可以进行提交操作，并有气泡提示
      return <Balloon.Tooltip
        align="t"
        trigger={
          <span className={`iconfont ${styles['disable-copy']} ${"icon-icon4-20"}`} />
        }
        closable={false}
      >
        画布内节点设置有误，请点击编辑重新设置
      </Balloon.Tooltip>
    } else if (item.processKey === '' || item.campaignState === 1 || item.executionPlan.checkPassFlag !== 1) {
      // processkey为空或者已提交或者节点校验未通过，禁用提交按钮
      return <ProcessSpan icon="icon-icon4-20" />;
    } else if (item.campaignState === 2 || item.campaignState === 9) {
      // 待执行或已完成，禁用暂停按钮
      return <ProcessSpan icon="icon-icon4-16" />;
    } else if (item.campaignState === 3) {
      // 执行中，可暂停
      // return (
      //   <ProcessBtn
      //     icon="icon-icon4-16"
      //     text="暂停"
      //     onClick={() => pauseActivity(item.id)}
      //   />
      // );

      // 2022.11.11 由于大促期间，客服对功能的不理解，导致对接客户时，没有解释清楚，赔付了1w费用，所以暂时禁用暂停功能
      return <ProcessSpan icon="icon-icon4-16" />;
    } else if (item.campaignState === 4) {
      // 已暂停可以继续
      return (
        <ProcessBtn
          icon="icon-icon4-17"
          text="继续"
          onClick={() => continueActivity(item)}
        />
      );
    } else if (item.campaignState === 5) {
      // 已停止禁用按钮
      return <ProcessSpan icon="icon-icon4-16" />;
    } else {
      // 兜底选项
      return <ProcessSpan icon="icon-icon4-16" />;
    }
  };
  /**
   * 判断流程操作第四个按钮（暂停预执行，彻底停止）操作如何展示
   * @param ProcessBtn: 可以操作的按钮
   * @param ProcessSpan: 禁用的按钮
   * @return 不同状态赋予不同点击事件和图标 (processkey不为空，证明已经在画布画出流程)
   */
  const checkStopStatus = (item) => {
    if (item.campaignState === 1) {
      // 预执行状态，可以进行停止预执行操作
      return (
        <ProcessBtn
          icon="icon-icon4-14"
          text="停止预执行"
          onClick={() => stopPreActivity(item.id)}
        />
      );
    } else if (
      item.campaignState === 2 ||
      item.campaignState === 3 ||
      item.campaignState === 4
    ) {
      // 执行中，已暂停状态，可以停止活动
      return (
        <ProcessBtn
          icon="icon-icon4-15"
          text="停止执行"
          onClick={() => secondConfirmDelete(item.id, 'stop')}
        />
      );
    } else {
      // 待执行或已完成，禁用暂停按钮
      return <ProcessSpan icon="icon-icon4-15" />;
    }
  };

  /**
   * 表格 当前执行进度列，如果是已经开始执行后且是循环活动，可以点击查看不同节点状态
   * @param type: 标识是否可以点击查看
   * @return 进度条结构
   */
  const processCol = (item, type = false) => {
    // 判断当次循环又没有执行失败的节点，样式需要展示警示叹号
    let tips = false;
    if (
      item.processKey &&
      item.campaignState === 3 &&
      item.canvasProcessDetail.processRuntimeData.length
    ) {
      item.canvasProcessDetail.processRuntimeData[
        item.cycleIndex ? item.cycleIndex - 1 : 0
      ].actInsts.forEach((it) => {
        if (
          it.actInstData &&
          item.canvasProcessDetail.processRuntimeData[
            item.cycleIndex ? item.cycleIndex - 1 : 0
          ].errorMsg[`${it.resourceId}`]
        ) {
          tips = true;
        }
      });
    }
    return (
      <div
        className={`${styles.displayFlex} ${styles.progressSpeed} ${type ? styles.cursorPointer : ''
          }  `}
      >
        {
          item.campaignState === 1 ? <div>--</div> : <>
            <div className={styles.grayBar}>
              <div
                className={
                  statusList.filter((obj) => obj.key === item.campaignState)[0]
                    ?.progressSpeed
                }
                style={{
                  width: `${item.currentProgress}%`,
                  background: tips ? '#FF9900' : '',
                }}
              />
            </div>
            <div style={{ minWidth: '32px' }}>
              {item.campaignState === 9 ? (
                <span
                  className="iconfont icon-icon4-24"
                  style={{ color: '#00bb66' }}
                />
              ) : tips ? (
                <span
                  className="iconfont icon-icon4-36"
                  style={{ color: '#FF9900' }}
                />
              ) : (
                <span>{item.currentProgress}%</span>
              )}
            </div>
          </>
        }
      </div>
    );
  };
  const [pageNoTip, setPageNoTip] = useState(0); // 解决setInterval每次获取的pageInfo都是useState的初始值
  // 初始加载活动列表
  useEffect(() => {
    clearInterval(intervals);
    intervals = setInterval(() => {
      setPageNoTip(pageNoTip + 10); // 如果写在空的useEffect中，会导致每次都拿到初始化的pageNo：1，
    }, 2000 * 60);
    searchActivityList({
      pageNo: pageInfo.pageNo,
      pageSize: pageInfo.pageSize,
    });
  }, [pageNoTip]);

  useEffect(() => {
    // const isShowFncDialog = JSON.parse(localStorage.getItem('isShowFncDialogCanvasThirdTips'));
    // if(isShowFncDialog !== null) { //存过localStorage
    //   setCheck(!isShowFncDialog);
    //   if(isShowFncDialog) { // 展示弹窗
    //     setShowNotice(true);
    //   } else { // 不展示弹窗
    //     setShowNotice(false);
    //   }
    // } else { // 没有存过localStorage
    //   setShowNotice(true);
    // }

    // 运营活动弹窗开放处
    // checkShowDialog();
    return () => {
      clearInterval(intervals); // 需要在离开这个页面时销毁interval
    };
  }, []);

  return (
    <div>
      <div className={styles.canvasActivityList}>
        {/* <div className={`${styles['guide-div-second']}`}>
            <div className={styles['guide-div']}>
                {
                    HEADERDESC.map(item => <div className={styles['guide-item']} style={{background: `url(${item.bg})`, backgroundSize: '100% 100%'}}>
                        <div className={styles['guide-item-icon']}>
                            <img src={item.icon} alt="" />
                        </div>
                        <div>
                            <div className={styles['guide-item-title']}>{item.title}</div>
                            <div className={styles['guide-item-desc']}>{item.desc}</div>
                        </div>
                    </div>)
                }
            </div> */}
        {/* <div className={styles['guide-link']}>
                <div className={styles['guide-link-div']} onClick={() => {
                        window.open(
                            'https://s3.cn-north-1.jdcloud-oss.com/lz-marketing/media/canvas.mp4'
                        );
                }}>
                    <img src={VIDEO} />
                    <span>画布 2.0 讲解</span>
                </div>
                <div className={styles['guide-link-div']} onClick={() => {
                    window.open(
                        'https://joyspace.jd.com/pages/AaeQt8CrHG4GdE4l1pRd'
                    );
                }}>
                    <img src={HELP} />
                    <span>查看帮助教程</span>
                </div>
            </div>
        </div> */}
        <section className="lz-section activity-list">
          <div className={styles.currentList}>
            <div className={styles.listSearch}>
              <Form
                inline
                className={`${styles.listSearchForm} form-crowdMarketing`}
                size="medium"
              // value={searchFormData} // onChange={handleSearchFormData}
              >
                <Form.Item
                  label="活动名称:"
                  className={styles.formItem}
                >
                  <Input
                    name="campaignName"
                    className={styles.formItem_width}
                    placeholder="请输入活动名称"
                    // maxLength={100}
                    hasClear
                    value={formSelectStatus.campaignName}
                    onChange={(val) =>
                      setFormSelectStatus({
                        ...formSelectStatus,
                        campaignName: val,
                      })
                    }
                  />
                </Form.Item>

                <Form.Item
                  label="创建时间:"
                  className={styles.formItem}
                >
                  <DatePicker.RangePicker
                    className={styles.formItem_width}
                    placeholder={['开始时间', '结束时间']}
                    hasClear
                    followTrigger
                    value={[formSelectStatus.startTime, formSelectStatus.endTime]}
                    onChange={changeActivityTime}
                  />
                </Form.Item>

                {/* <Form.Item
                  label="循环方式："
                  className={styles.formItem}
                >
                  <Select
                    followTrigger
                    hasClear
                    className={styles.formItem_width}
                    value={formSelectStatus.cycleType}
                    onChange={(type) =>
                      setFormSelectStatus({
                        ...formSelectStatus,
                        cycleType: type,
                      })
                    }
                    placeholder="请选择循环方式"
                  >
                    <Select.Option value={1} key={1}>
                      单次
                    </Select.Option>
                    <Select.Option value={2} key={2}>
                      循环
                    </Select.Option>
                  </Select>
                </Form.Item> */}

                <Form.Item
                  label="活动状态:"
                  className={styles.formItem}
                >
                  <Select
                    followTrigger
                    size="small"
                    hasClear
                    className={styles.formItem_width}
                    value={formSelectStatus.campaignState}
                    onChange={(statu) =>
                      setFormSelectStatus({
                        ...formSelectStatus,
                        campaignState: statu,
                      })
                    }
                    placeholder="请选择活动状态"
                  >
                    {statusList.map((r, index) => (
                      <Select.Option value={r.key} key={`status${index}`}>
                        {r.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>

                {/* 其实没必要，把按钮拉出去就行，但是懒得改了，保留吧 */}
                <Form.Item label=" " className={styles.formItem}></Form.Item>
                <Form.Item
                  label=" "
                  hasFeedback
                  className={`${styles.formItem}`}
                  style={{ textAlign: 'right' }}
                >
                  <Button
                    type="primary"
                    className={`${styles.mr10} ${styles.w88}`}
                    onClick={searchBtnFun}
                  >
                    查询
                  </Button>
                  <Button
                    type="normal"
                    className={styles.w88}
                    onClick={resetFilter}
                  >
                    重置
                  </Button>
                </Form.Item>
              </Form>
            </div>
<div className={styles.childBox}>
            <Form style={{ width: '100%' }}>
              <Form.Item
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flex: 1
                }}
              >
                <CreateBtn
                  name="新增营销活动"
                  toCreateHandle={() => {
                    initCanvasData();
                    setDialogTitle(1);
                    setStrategyFlag(!strategyFlag);
                  }}
                />
              </Form.Item>
            </Form>
            <div style={{ clear: 'both' }} />
            <Table
              loading={isLoading}
              dataSource={activityData}
              className={styles.customTable}
            >
              {/* <Table.Column
                title="循环方式"
                key="executionPlan"
                cell={(value, index, item) => (
                  <span className={styles.stateText}>
                    {item.executionPlan.type === 1 ? (
                      <img src="//img10.360buyimg.com/imgzone/jfs/t1/142572/9/6887/529/5f48a35fE1296fb68/6403bbab1f1b64b7.png" />
                    ) : (
                      <img src="//img10.360buyimg.com/imgzone/jfs/t1/129797/12/8419/576/5f48a35eE46d8e268/43fad9dcd9a79291.png" />
                    )}
                  </span>
                )}
              /> */}
              <Table.Column
                title="活动名称"
                dataIndex="campaignName"
                key="campaignName"
              />
              <Table.Column
                title="活动编码"
                dataIndex="id"
                key="id"
              />
              <Table.Column
                title="创建时间"
                key="createTime"
                cell={(value, index, item) => (
                  <div>
                    {moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')}
                  </div>
                )}
              />
              <Table.Column
                className="table-balloon-column"
                title="任务数"
                key="jobNum"
                cell={(value, index, item) => (
                  <>
                    {item.processKey ? (
                      <Balloon
                        followTrigger
                        popupStyle={{
                          background: '#fff',
                          color: '#333333',
                          borderRadius: '2px',
                          width: '180px',
                        }}
                        align="r"
                        triggerType="click"
                        trigger={
                          <span className={styles.cursorPointer}>
                            {item.jobNum}
                          </span>
                        }
                        closable={false}
                        onVisibleChange={(visible) =>
                          visible ? searchActivityTaskDetail(item) : {}
                        }
                      >
                        <div>
                          <div
                            style={{ marginTop: 0 }}
                            className={`${styles.displayFlex} ${styles.taskNumbers}`}
                          >
                            <div>节点类型</div>
                            <div>数量</div>
                          </div>
                          <hr />
                          <div className={styles.dialogContent}>
                            {taskDetailList.length &&
                              taskDetailList.map(
                                (r, index) =>
                                  r.value > 0 && (
                                    <div
                                      key={index}
                                      className={`${styles.displayFlex} ${styles.taskNumbers}`}
                                    >
                                      <div>{r.name}</div>
                                      <div>{r.value}</div>
                                    </div>
                                  )
                              )}
                          </div>
                        </div>
                      </Balloon>
                    ) : (
                      <span className={styles.cursorPointer}>--</span>
                    )}
                  </>
                )}
              />
              {/* <Table.Column
                className="table-balloon-column"
                title="执行循环次数"
                key="cycleIndex"
                cell={(value, index, item) => (
                  <div>
                    {item.canvasProcessDetail &&
                      item.canvasProcessDetail.processRuntimeData.length >
                      0 && (
                        <Balloon
                          followTrigger
                          popupStyle={{
                            background: '#fff',
                            color: '#333333',
                            borderRadius: '2px',
                            width: '180px',
                          }}
                          align="r"
                          triggerType="click"
                          trigger={
                            <span className={styles.cursorPointer}>
                              {
                                item.canvasProcessDetail.processRuntimeData
                                  .length
                              }
                            </span>
                          }
                          closable={false}
                          onVisibleChange={(visible) =>
                            visible ? searchActivityLoopDetail(item) : {}
                          }
                        >
                          <div>
                            <div
                              style={{ marginTop: 0 }}
                              className={`${styles.displayFlex} ${styles.taskNumbers}`}
                            >
                              <div>循环次数</div>
                              <div>执行进度</div>
                            </div>
                            <hr />
                            <div className={styles.dialogContent}>
                              {loopDetailList.length &&
                                loopDetailList.map((r, index) => (
                                  <div
                                    key={index}
                                    className={`${styles.displayFlex} ${styles.taskNumbers} ${styles.currentList}`}
                                  >
                                    <div>{r.name}</div>
                                    <div
                                      key={index}
                                      className={`${styles.displayFlex} ${styles.progressSpeed} ${styles.taskNumbers}`}
                                    >
                                      <div
                                        className={styles.grayBar}
                                        style={{ marginRight: '5px' }}
                                      >
                                        <div
                                          className={
                                            statusList.filter(
                                              (obj) =>
                                                obj.key === item.campaignState
                                            )[0]?.progressSpeed
                                          }
                                          style={{
                                            width: `${item.currentProgress}%`,
                                            background: r.tips ? '#FF9900' : '',
                                          }}
                                        />
                                      </div>
                                      <div style={{ minWidth: '32px' }}>
                                        {item.campaignState === 9 ? (
                                          <span
                                            className="iconfont icon-icon4-24"
                                            style={{ color: '#00bb66' }}
                                          />
                                        ) : r.tips ? (
                                          <span
                                            className="iconfont icon-icon4-36"
                                            style={{ color: '#FF9900' }}
                                          />
                                        ) : (
                                          <span>{item.currentProgress}%</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        </Balloon>
                      )}
                    {(!item.canvasProcessDetail ||
                      item.canvasProcessDetail.processRuntimeData.length ===
                      0) && <span>--</span>}
                  </div>
                )}
              /> */}
              <Table.Column
                title="活动状态"
                key="campaignState"
                cell={(value, index, item) => (
                  <span
                    className={`${statusList.filter(
                      (obj) => obj.key === item.campaignState
                    )[0]?.classname
                      }`}
                  >
                    {
                      statusList.filter(
                        (obj) => obj.key === item.campaignState
                      )[0]?.name
                    }
                  </span>
                )}
              />
              <Table.Column
                className="table-balloon-column"
                title="当前执行进度"
                key="currentProgress"
                cell={(value, index, item) => (
                  <>
                    {/* 活动已执行后且为循环活动，可以查看本次活动各节点执行状态 */}
                    {/* {
                      (item.campaignState >= 3 && item.executionPlan.type !== 1) ?  */}
                    <Balloon
                      followTrigger
                      popupStyle={{
                        color: '#fff',
                        borderRadius: '2px',
                        width: '180px',
                      }}
                      align="r"
                      triggerType="click"
                      trigger={processCol(item, true)}
                      closable={false}
                      onVisibleChange={(visible) =>
                        visible ? searchActivityProcessDetail(item) : {}
                      }
                    >
                      <>
                        {item.processKey && item.campaignState !== 1 && (
                          <div>
                            <div
                              style={{ marginTop: 0 }}
                              className={`${styles.displayFlex} ${styles.taskNumbers}`}
                            >
                              <div>节点类型</div>
                              <div>数量</div>
                            </div>
                            <hr />
                            <div className={styles.dialogContent}>
                              {processDetailList.length &&
                                processDetailList.map((r, index) => (
                                  <div
                                    key={index}
                                    className={`${styles.displayFlex} ${styles.taskNumbers}`}
                                  >
                                    <div>{r.name}</div>
                                    <div>{r.value}</div>
                                  </div>
                                ))}
                            </div>
                          </div>
                        )}
                        {item.processKey && item.campaignState === 1 && (
                          <div>请进入详情页面查看预执行进度</div>
                        )}
                        {!item.processKey && <div>此活动未进行流程编辑</div>}
                      </>
                    </Balloon>
                    {/* :
                      processCol(item, false)
                    } */}
                  </>
                )}
              />
              {/* 活动状态 0-未提交 1-预执行 2-待执行 3-执行中 4-已暂停 5-已停止 9-已完成 */}
              <Table.Column
                title="流程操作"
                key="campaignState"
                cell={(value, index, item) => (
                  <div className={styles.operation}>
                    {/* 活动状态为0，即未提交时，可以进行编辑 */}
                    <div
                      className={
                        item.campaignState === 0
                          ? styles.cursorPointer
                          : styles.cursorNot
                      }
                    >
                      {item.campaignState === 0 ? (
                        <Balloon.Tooltip
                          align="t"
                          trigger={
                            <span
                              className="iconfont icon-icon-08"
                              onClick={() => editActivity(item)}
                            />
                          }
                          closable={false}
                        >
                          编辑
                        </Balloon.Tooltip>
                      ) : (
                        <span
                          className={`iconfont ${styles['disable-copy']} icon-icon-08`}
                        />
                      )}
                    </div>
                    {/* 除去活动状态为0-未提交，其余都可以查看详情 */}
                    <div
                      className={
                        item.campaignState === 0
                          ? styles.cursorNot
                          : styles.cursorPointer
                      }
                    >
                      {item.campaignState === 0 ? (
                        <span
                          className={`iconfont icon-icon4-18 ${styles['disable-copy']}`}
                        />
                      ) : (
                        <Balloon.Tooltip
                          align="t"
                          trigger={
                            <span
                              className="iconfont icon-icon4-18"
                              onClick={() => viewCanvasDetail(item)}
                            />
                          }
                          closable={false}
                        >
                          详情
                        </Balloon.Tooltip>
                      )}
                    </div>
                    {/* 调用方法判断是提交，暂停，继续哪一种操作，可点击还是禁用状态 */}
                    <div
                      className={
                        item.campaignState === 1 ||
                          item.campaignState === 2 ||
                          item.campaignState === 5 ||
                          item.campaignState === 9 ||
                          item.processKey === ''
                          ? styles.cursorNot
                          : styles.cursorPointer
                      }
                    >
                      {checkOperationStatus(item)}
                    </div>
                    {/* 调用方法判断是停止预执行还是完全停止，可点击还是禁用状态 */}
                    <div
                      className={
                        item.campaignState === 1 ||
                          item.campaignState === 2 ||
                          item.campaignState === 3 ||
                          item.campaignState === 4
                          ? styles.cursorPointer
                          : styles.cursorNot
                      }
                    >
                      {checkStopStatus(item)}
                    </div>
                  </div>
                )}
              />
              <Table.Column
                title="活动操作"
                key="campaignState"
                cell={(value, index, item) => (
                  <div className={`${styles.operation} ${styles['activity-operation']}`}>
                    {/* processkey为空，即没有画布流程时，可以进行活动修改，其余状态均为查看 */}
                    <span
                      style={{ whiteSpace: 'nowrap' }}
                      className={styles.globalLink}
                      onClick={() =>
                        item.campaignState <= 0
                          ? editActivityMessage(item)
                          : viewActivityDetail(item)
                      }
                    >
                      {item.campaignState <= 0 ? '修改' : '查看'}
                    </span>
                    {/* processkey为空不可进行复制 */}
                    {item.processKey === '' ? (
                      <span
                        style={{ whiteSpace: 'nowrap' }}
                        className={`${styles.cursorNot} ${styles['disable-copy']}`}
                      >
                        复制
                      </span>
                    ) : (
                      <span
                        style={{ whiteSpace: 'nowrap' }}
                        className={styles.globalLink}
                        onClick={() => {
                          setCopyId(item.id),
                            setDialogTitle(2),
                            setCanvasData(item),
                            setStrategyFlag(!strategyFlag);
                        }}
                      >
                        复制
                      </span>
                    )}
                    {/* campaignState为0，即未提交状态，可进行删除操作，其余状态只能查看活动报表 */}
                    {
                      item.campaignState > 0 &&
                      <span
                        style={{ whiteSpace: 'nowrap' }}
                        className={styles.globalLink}
                        onClick={() =>
                          // item.campaignState === 0
                          //   ? secondConfirmDelete(item.id, 'del')
                          //   : viewAnalysis(item)
                          viewAnalysis(item)
                        }
                      >
                        {/* {item.campaignState === 0
                          ? '删除'
                          : item.campaignState > 0
                          ? '报表'
                          : ''} */}
                        报表
                      </span>
                    }

                    <span
                      style={{ whiteSpace: 'nowrap' }}
                      className={styles.globalLink}
                      onClick={() =>
                        secondConfirmDelete(item.id, 'del')
                      }>
                      删除
                    </span>
                    {/* <span style={{whiteSpace: "nowrap", display: item.campaignState === 0 ? 'block' : 'none'}} className={styles.globalLink} onClick={() => item.campaignState === 0 ? secondConfirmDelete(item.id, 'del') : viewAnalysis(item.id)}>{ item.campaignState === 0 ? '删除' : ''}</span> */}
                  </div>
                )}
              />
            </Table>
            <LzPagination pageInfo={pageInfo} onChange={handlePageSizeChange} />
            </div>
            {/* 新建/复制/修改 营销活动弹窗 */}
            <LzDialog
              footer={false}
              shouldUpdatePosition
              isFullScreen
              visible={strategyFlag}
              title={
                dialogTitle === 1
                  ? '新增自定义活动'
                  : dialogTitle === 2
                    ? '复制自定义活动'
                    : '修改自定义活动'
              }
              onClose={() => setStrategyFlag(false)}
            >
              <CanvasDialog
                canvasFormdata={canvasData}
                submitFunc={saveFormData}
                cancelFunc={canvasCancel}
                dialogTitle={dialogTitle}
              />
            </LzDialog>
            {/* 查看营销活动详情弹窗 */}
            <LzDialog
              footer={false}
              shouldUpdatePosition
              visible={activityDetailFlag}
              title="活动详情"
              onClose={() => setActivityDetailFlag(false)}
            >
              <DetailDialog
                canvasFormdata={canvasData}
                cancelFunc={() => setActivityDetailFlag(false)}
              />
            </LzDialog>
            {/* 二次确认删除弹窗 */}
            {deleteItemFlag && (
              <ConfirmDialog
                type="WARN"
                title="提示"
                promptInfo={
                  deleteItemType === 'del'
                    ? '确认删除该条数据？'
                    : '确认停止该活动？'
                }
                flag={deleteItemFlag}
                confirmHandel={
                  deleteItemType === 'del' ? deleteAvtivity : stopActivity
                }
                cancelHandel={() => {
                  setDeleteItemFlag(false);
                }}
              />
            )}
          </div>
        </section>
      </div>

      {/* 公告弹窗，编辑页返回时不提示 */}
      {/* {
        props.location.state?.source !== 'editor' && <SMSDialog />
      } */}
      {/* 短信优惠弹窗 */}
      {/* {
          props.location.state?.source !== 'editor' && showOperationDialog && <OperationDialog closeDialog={() => { setShowOperationDialog(false) }} />
      } */}
      {/* 画布2.0功能弹窗 */}
      {/* {
            isShowFncSummary  && <FunctionUseSummary isShowFncSummary={ isShowFncSummary } openFncSummary = {() => setIsShowFncSummary(true)} closeFncSummary={() => setIsShowFncSummary(false)} videoSrc='https://s3.cn-north-1.jdcloud-oss.com/lz-marketing/media/canvas.mp4' tip='isShowFncDialogCanvasFirst'/>
        } */}
      {
        // 画布2.1通知弹窗
        showNotice &&
        <LzDialog
          visible={showNotice}
          title=''
          style={{
            width: '400px',
            height: '260px',
            backgroundImage: `url(//img10.360buyimg.com/imgzone/jfs/t1/188161/31/51191/9251/674fc32bF002a9e0f/19aecdf678260553.png)`,
            backgroundRepeat: 'no-repeat',
            borderRadius: '14px',
            border: 'none'
          }}
          footer={false}
          closeable={false}
        >
          <div
            style={{
              position: 'relative',
              top: '172px',
              left: '244px',
              width: '88px',
              height: '33px',
              cursor: 'pointer'
            }}
            onClick={() => { setShowNotice(false) }}
          />
          <Checkbox
            checked={isCheck}
            onChange={(checked) => handleCheck(checked)}
            style={{
              position: 'relative',
              top: '138px',
              left: '20px',
              height: '30px',
              lineHeight: '30px'
              }}
            >
            <span
              style={{
                color: 'rgba(0, 0, 0, 0.65)',
                marginLeft: "2px"
              }}
            >
              不再展示
            </span>
          </Checkbox>
        </LzDialog>
      }
    </div>
  );
}
